import { render, staticRenderFns } from "./castingCalls.vue?vue&type=template&id=08828a8d&scoped=true&"
import script from "./castingCalls.vue?vue&type=script&lang=js&"
export * from "./castingCalls.vue?vue&type=script&lang=js&"
import style0 from "./castingCalls.vue?vue&type=style&index=0&id=08828a8d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08828a8d",
  null
  
)

export default component.exports